import {observable, extendObservable} from "mobx";
import {pad, stringToArray, formatarCPF} from "../../../utils/functions";
import moment from "moment/moment";
import _ from "lodash";
import {
    CentroCustoDebitoService,
    AreaService,
    CargoService,
    CentralService,
    DepartamentoService,
    DivisaoService,
    EmpresaGloboService,
    ETTService,
    JustificativaContratacaoService,
    MOTService,
    ProdutoService
} from "../../../services";

import PisoSalarialService from "../../../services/PisoSalarialService";

export default class FiltroStore {
    @observable exportOpen;

    @observable areas = [];
    @observable divisoes = [];
    @observable centrais = [];
    @observable departamentos = [];
    @observable cargos = [];
    @observable empresas = [];
    @observable fornecedores = [];
    @observable competenciaInicioSelecionada;
    @observable competenciaFimSelecionada;
    @observable competenciaMesInicioSelecionada;
    @observable competenciaMesFimSelecionada;
    @observable produtos = [];
    @observable centrosCustoDebito = [];
    @observable excluindoSazonalidadeSelecionada;
    @observable dataInicialSelecionada;
    @observable dataFinalSelecionada;
    @observable situacoesSolicitacao = [];
    @observable situacoesTimesheet = [];
    @observable justificativas = [];
    @observable competenciaTerminoContratoSelecionada;
    @observable quantidadeAcessoConsecutivoSelecionada;
    @observable quantidadeAcessoAlternadoSelecionada;
    @observable cpfSelecionado;
    @observable motsSelecionados;
    @observable competenciaSelecionada;
    @observable numeroLoteSelecionado;
    @observable numeroRCSelecionado;
    @observable numeroOCSelecionado;
    @observable numeroNFSelecionado;

    @observable areasValidacao;
    @observable divisoesValidacao;
    @observable centraisValidacao;
    @observable departamentosValidacao;
    @observable cargosValidacao;
    @observable empresasValidacao;
    @observable fornecedoresValidacao;
    @observable competenciaInicioValidacao;
    @observable competenciaFimValidacao;
    @observable competenciaMesInicioValidacao;
    @observable competenciaMesFimValidacao;
    @observable produtosValidacao;
    @observable centrosCustoDebitoValidacao;
    @observable dataInicialValidacao;
    @observable dataFinalValidacao;
    @observable situacoesSolicitacaoValidacao;
    @observable situacoesTimesheetValidacao;
    @observable justificativasValidacao;
    @observable tipoFiltroRelSolicitacoes = [];
    @observable tipoFiltroRelSolicitacoesValidacao = "";
    @observable sindicatos = [];
    @observable sindicatosValidacao;

    constructor(dataInicialFiltroValue) {
        this.centroCustoDebitoService = new CentroCustoDebitoService();
        this.areaService = new AreaService();
        this.cargoService = new CargoService();
        this.centralService = new CentralService();
        this.departamentoService = new DepartamentoService();
        this.divisaoService = new DivisaoService();
        this.empresaGloboService = new EmpresaGloboService();
        this.ettService = new ETTService();
        this.justificativaContratacaoService = new JustificativaContratacaoService();
        this.motService = new MOTService();
        this.produtoService = new ProdutoService();
        this.pisoSalarialService = new PisoSalarialService();

        if(dataInicialFiltroValue){
            this.dataInicialValidacao =  moment(dataInicialFiltroValue).format("DD/MM/YYYY");
            this.dataInicialSelecionada =   dataInicialFiltroValue;
        }
        this.filtro = {};
    }

    carregarListas = (params, fields) => {
        extendObservable(this.filtro, params);

        _.includes(fields, "AREA") && this.carregarAreas();
        _.includes(fields, "CENTRAL") && this.carregarCentrais();
        _.includes(fields, "DIVISAO") && this.carregarDivisoes();
        _.includes(fields, "DEPARTAMENTO") && this.carregarDepartamentos();
        _.includes(fields, "CARGO") && this.carregarCargos();
        _.includes(fields, "EMPRESA") && this.carregarEmpresas();
        _.includes(fields, "FORNECEDOR") && this.carregarFornecedores();
        _.includes(fields, "COMPETENCIA_INICIO") && this.carregarCompetenciaInicio();
        _.includes(fields, "COMPETENCIA_FIM") && this.carregarCompetenciaFim();
        _.includes(fields, "COMPETENCIA_MES_INICIO") && this.carregarCompetenciaMesInicio();
        _.includes(fields, "COMPETENCIA_MES_FIM") && this.carregarCompetenciaMesFim();
        _.includes(fields, "PRODUTO") && this.carregarProdutos();
        _.includes(fields, "AR_DEBITO") && this.carregarCentrosCustoDebito();
        _.includes(fields, "SAZONALIDADE") && this.carregarExcluindoSazonalidade();
        _.includes(fields, "DATA_INICIAL") && this.carregarDataInicial();
        _.includes(fields, "DATA_FINAL") && this.carregarDataFinal();
        _.includes(fields, "SITUACAO_SOLICITACAO") && this.carregarSituacoesSolicitacao();
        _.includes(fields, "JUSTIFICATIVA") && this.carregarJustificativas();
        _.includes(fields, "COMPETENCIA_TERMINO_CONTRATO") && this.carregarCompetenciaTerminoContrato();
        _.includes(fields, "QUANTIDADE_ACESSO_CONSECUTIVO") && this.carregarQuantidadeAcessoConsecutivo();
        _.includes(fields, "QUANTIDADE_ACESSO_ALTERNADO") && this.carregarQuantidadeAcessoAlternado();
        _.includes(fields, "CPF") && this.carregarCPF();
        _.includes(fields, "MOT") && this.carregarMOTs();
        _.includes(fields, "COMPETENCIA") && this.carregarCompetencia();
        _.includes(fields, "NUMERO_LOTE") && this.carregarNumeroLote();
        _.includes(fields, "NUMERO_RC") && this.carregarNumeroRC();
        _.includes(fields, "NUMERO_OC") && this.carregarNumeroOC();
        _.includes(fields, "NUMERO_NF") && this.carregarNumeroNF();
        _.includes(fields, "SITUACAO_TIMESHEET") && this.carregarSituacoesTimesheet();
        _.includes(fields, "TIPO_FILTRO_REL_SOLICITACOES") && this.carregarTipoFiltroRelSolicitacoes();
        _.includes(fields, "SINDICATO") && this.carregarSindicatos();
    }

    carregarAreas = () => {
        this.areasValidacao = this.filtro.areas;

        this.areaService.list().then(response => {
            let areas = response.data
                .filter(area => area)
                .map(area => ({
                    value: area.nome,
                    label: area.nome
                }));

            areas = [ ...areas, {
                value: -1,
                label: "(Não informado)"
            }];

            this.areas = _.orderBy(areas, ["label"], ["asc"]);
        }).catch(error => {
            this.erro = error;
        });
    }

    carregarCentrais = () => {
        this.centraisValidacao = this.filtro.centrais;
        
        this.centralService.list().then(response => {
            let centrais = response.data
                .filter(central => central)
                .map(central => ({
                    value: central ? central.nome : "(não informado)",
                    label: central ? central.nome : "(não informado)"
                }));

            centrais = [ ...centrais, {
                value: -1,
                label: "(não informado)"
            }];

            this.centrais = _.orderBy(centrais, ["label"], ["asc"]);
        }).catch(error => {
            this.erro = error;
        });
    }

    carregarDivisoes = () => {
        this.divisoesValidacao = this.filtro.divisoes;
        
        this.divisaoService.list().then(response => {
            let divisoes = response.data
                .filter(divisao => divisao)
                .map(divisao => ({
                    value: divisao.nome,
                    label: divisao.nome
                }));

            divisoes = [ ...divisoes, {
                value: -1,
                label: "(não informado)"
            }];

            this.divisoes = _.orderBy(divisoes, ["label"], ["asc"]);
        }).catch(error => {
            this.erro = error;
        });
    }

    carregarDepartamentos = () => {
        this.departamentosValidacao = this.filtro.departamentos;
        
        this.departamentoService.list().then(response => {
            let departamentos = response.data
                .filter(departamento => departamento)
                .map(departamento => ({
                    value: departamento.nome,
                    label: departamento.nome
                }));

            departamentos = [ ...departamentos, {
                value: -1,
                label: "(não informado)"
            }];

            this.departamentos = _.orderBy(departamentos, ["label"], ["asc"]);
        }).catch(error => {
            this.erro = error;
        });
    }

    carregarCargos = () => {
        this.cargosValidacao = this.filtro.cargos;
        
        this.cargoService.listFromBase().then(response => {
            let cargos = response.data
                .filter(cargo => cargo)
                .map(cargo => ({
                    value: cargo.id,
                    label: cargo.nome
                }));

            cargos = [ ...cargos, {
                value: -1,
                label: "(sem cargo)"
            }];

            this.cargos = _.orderBy(cargos, ["label"], ["asc"]);
        }).catch(error => {
            this.erro = error;
        });
    }

    carregarEmpresas = () => {
        this.empresasValidacao = this.filtro.empresas;
        
        this.empresaGloboService.list().then(response => {
            let empresas = response.data
                .filter(empresa => empresa)
                .map(empresa => ({
                    value: empresa.id,
                    label: empresa.nome
                }));

            empresas = [ ...empresas, {
                value: -1,
                label: "(sem unidade de negócio)"
            }];

            this.empresas = _.orderBy(empresas, ["label"], ["asc"]);
        }).catch(error => {
            this.erro = error;
        });
    }

    carregarFornecedores = () => {
        this.fornecedoresValidacao = this.filtro.fornecedores;
        
        this.ettService.list().then(response => {
            let fornecedores = response.data
                .filter(fornecedor => fornecedor)
                .map(fornecedor => ({
                    value: fornecedor.id,
                    label: fornecedor.nomeFantasia
                }));

            fornecedores = [ ...fornecedores, {
                value: -1,
                label: "(sem fornecedor)"
            }];

            this.fornecedores = _.orderBy(fornecedores, ["label"], ["asc"]);
        }).catch(error => {
            this.erro = error;
        });
    }

    carregarCompetenciaInicio = () => {
        if(this.filtro.competenciaInicio) {
            this.competenciaInicioValidacao = moment(this.filtro.competenciaInicio).format("DD/MM/YYYY");
            this.competenciaInicioSelecionada = moment(this.filtro.competenciaInicio, "YYYY-MM-DD");
        }
    }

    carregarCompetenciaFim = () => {
        if(this.filtro.competenciaFim) {
            this.competenciaFimValidacao = moment(this.filtro.competenciaFim).format("DD/MM/YYYY");
            this.competenciaFimSelecionada = moment(this.filtro.competenciaFim, "YYYY-MM-DD");
        }
    }

    carregarCompetenciaMesInicio = () => {
        if(this.filtro.competenciaMesInicio) {
            try {
                const month = parseInt(this.filtro.competenciaMesInicio.substring(4));
                const year = parseInt(this.filtro.competenciaMesInicio.substring(0, 4));

                this.competenciaMesInicioSelecionada = { year, month };
                this.competenciaMesInicioValidacao = `01/${pad(month, 2)}/${year}`;
            } catch(error) {}
        }
    }

    carregarCompetenciaMesFim = () => {
        if(this.filtro.competenciaMesFim) {
            try {
                const month = parseInt(this.filtro.competenciaMesFim.substring(4));
                const year = parseInt(this.filtro.competenciaMesFim.substring(0, 4));

                this.competenciaMesFimSelecionada = { year, month };
                this.competenciaMesFimValidacao = `01/${pad(month, 2)}/${year}`;
            } catch(error) {}
        }
    }

    carregarProdutos = () => {
        this.produtosValidacao = this.filtro.produtos;
        
        this.produtoService.list().then(response => {
            let produtos = response.data
                .filter(produto => produto)
                .map(produto => ({
                    value: produto.id,
                    label: produto.nome + (produto.codigo ? ` (${produto.codigo})` : "")
                }));

            produtos = [ ...produtos, {
                value: -1,
                label: "(sem projeto/centro de resultado/finalidade)"
            }];

            this.produtos = _.orderBy(produtos, ["label"], ["asc"]);
        }).catch(error => {
            this.erro = error;
        });
    }

    carregarCentrosCustoDebito = () => {
        this.centrosCustoDebitoValidacao = this.filtro.centrosCustoDebito;
        
        this.centroCustoDebitoService.list().then(response => {
            let centrosCustoDebito = response.data
                .filter(centroCustoDebito => centroCustoDebito)
                .map(centroCustoDebito => ({
                    value: centroCustoDebito.centro,
                    label: centroCustoDebito.centro
                }));

            centrosCustoDebito = [ ...centrosCustoDebito, {
                value: -1,
                label: "(sem centro de custo)"
            }];

            this.centrosCustoDebito = _.orderBy(centrosCustoDebito, ["label"], ["asc"]);
        }).catch(error => {
            this.erro = error;
        });
    }

    carregarExcluindoSazonalidade = () => {
        this.excluindoSazonalidadeSelecionada = this.filtro.excluindoSazonalidade;
    }

    carregarDataInicial = () => {
        if(this.filtro.dataInicial) {
            this.dataInicialValidacao = moment(this.filtro.dataInicial).format("DD/MM/YYYY");
            this.dataInicialSelecionada = moment(this.filtro.dataInicial, "YYYY-MM-DD");
        }
    }

    carregarDataFinal = () => {        
        if(this.filtro.dataFinal) {
            this.dataFinalValidacao = moment(this.filtro.dataFinal).format("DD/MM/YYYY");
            this.dataFinalSelecionada = moment(this.filtro.dataFinal, "YYYY-MM-DD");
        }
    }

    carregarSituacoesSolicitacao = () => {
        this.situacoesSolicitacaoValidacao = this.filtro.situacoesSolicitacao;

        this.situacoesSolicitacao = [
        {
            value: "Em andamento",
            label: "Em andamento"
        }, {
            value: "Ainda não iniciada",
            label: "Ainda não iniciada"
        }, {
            value: "Cancelada",
            label: "Cancelada"
        }, {
            value: "Finalizada",
            label: "Finalizada"
        }, {
            value: "Reprovada",
            label: "Reprovada"
        }, {
            value: "Vigente",
            label: "Vigente"
        }];
    }
    
    carregarSituacoesTimesheet = () => {
        this.situacoesTimesheetValidacao = this.filtro.situacoesTimesheet;

        this.situacoesTimesheet = [
        {
            value: "NOV",
            label: "Novo"
        },{
          value: "PFL",
          label: "Pendente fluxo"
        }, {
            value: "PPR",
            label: "Pendente preenchimento"
        }, {
            value: "APR",
            label: "Aprovado"
        }, {
            value: "PPG",
            label: "Pendente pagamento"
        }, {
            value: "PAG",
            label: "Pago"
        }, {
            value: "PAV",
            label: "Pendente avaliação"
        }, {
            value: "PAJ",
            label: "Pendente ajuste"
        },{
            value: "ERA",
            label: "Erro de alocação"
          },{
            value: "ERF",
            label: "Erro de criação do fluxo"
          },{
            value: "CAN",
            label: "Cancelado"
          }, {
            value: "APA",
            label: "Aprovado automaticamente"
        }];
    }

    carregarJustificativas = () => {
        this.justificativasValidacao = this.filtro.justificativas;
        
        this.justificativaContratacaoService.list().then(response => {
            let justificativas = response.data
                .filter(justificativa => justificativa)
                .map(justificativa => ({
                    value: justificativa.nome,
                    label: justificativa.nome
                }));

            justificativas = [ ...justificativas, {
                value: -1,
                label: "(sem justificativa)"
            }];

            this.justificativas = _.orderBy(justificativas, ["label"], ["asc"]);
        }).catch(error => {
            this.erro = error;
        });
    }

    carregarCompetenciaTerminoContrato = () => {
        if(this.filtro.competenciaTerminoContrato) {
            try {
                this.competenciaTerminoContratoSelecionada = {
                    year: parseInt(this.filtro.competenciaTerminoContrato.substring(0, 4)),
                    month: parseInt(this.filtro.competenciaTerminoContrato.substring(4))
                }
            } catch(error) {}
        }
    }

    carregarQuantidadeAcessoConsecutivo = () => {
        this.quantidadeAcessoConsecutivoSelecionada = this.filtro.quantidadeAcessoConsecutivo;
    }

    carregarQuantidadeAcessoAlternado = () => {
        this.quantidadeAcessoAlternadoSelecionada = this.filtro.quantidadeAcessoAlternado;
    }

    carregarCPF = () => {
        this.cpfSelecionado = this.filtro.cpf;
    }

    carregarMOTs = () => {
        if(this.filtro.mots) {
            this.motService.listByIds(stringToArray(this.filtro.mots)).then(response => {
                this.motsSelecionados = response.data
                    .map(mot => `${mot.nomeCompleto} (${formatarCPF(mot.cpf)})`)
                    .join(",");
            })
        }
    }

    carregarCompetencia = () => {
        if(this.filtro.competencia) {
            try {
                this.competenciaSelecionada = {
                    year: parseInt(this.filtro.competencia.substring(0, 4)),
                    month: parseInt(this.filtro.competencia.substring(4))
                }
            } catch(error) {}
        }
    }

    carregarNumeroLote = () => {
        this.numeroLoteSelecionado = this.filtro.numeroLote;
    }

    carregarNumeroRC = () => {
        this.numeroRCSelecionado = this.filtro.numeroRc;
    }

    carregarNumeroOC = () => {
        this.numeroOCSelecionado = this.filtro.numeroOc;
    }

    carregarNumeroNF = () => {
        this.numeroNFSelecionado = this.filtro.numeroNF;
    }

    carregarSindicatos = () => {
        this.sindicatosValidacao = this.filtro.sindicatos;
        
        this.pisoSalarialService.listarSindicatos().then(response => {
            let sindicatos = response.data
                .filter(sindicato => sindicato)
                .map(sindicato => ({
                    value: sindicato.id,
                    label: sindicato.nome
                }));

            sindicatos = [ ...sindicatos, {
                value: -1,
                label: "(sem sindicatos)"
            }];

            this.sindicatos = _.orderBy(sindicatos, ["label"], ["asc"]);
        }).catch(error => {
            this.erro = error;
        });
    }

    filtrarMOTs = (input, callback)=> {
        if(!(input && input.length > 1)) {
            callback(null, { options: [], complete: false });
            return;
        }

        this.motService.listByPrefixoNome(input).then(response => {
            let mots = response.data
                .filter(mot => mot)
                .map(mot => ({
                    id: mot.id,
                    value: `${mot.nomeCompleto} (${formatarCPF(mot.cpf)})`,
                    label: `${mot.nomeCompleto} (${formatarCPF(mot.cpf)})`
                }));

            mots = _.orderBy(mots, ["label"], ["asc"]);

            callback(null, {
                options: mots,
                complete: false
            });
        }).catch(error => {
            callback(null, { options: [], complete: false });
            this.erro = error;
        });
    }

    setAreas = (value) => {
        this.filtro.areas = value;
        this.areasValidacao = value;
    }

    setCentrais = (value) => {
        this.filtro.centrais = value;
        this.centraisValidacao = value;
    }

    setDivisoes = (value) => {
        this.filtro.divisoes = value;
        this.divisoesValidacao = value;
    }

    setDepartamentos = (value) => {
        this.filtro.departamentos = value;
        this.departamentosValidacao = value;
    }

    setCargos = (value) => {
        this.filtro.cargos = value;
        this.cargosValidacao = value;
    }

    setEmpresas = (value) => {
        this.filtro.empresas = value;
        this.empresasValidacao = value;
    }
    setSindicatos = (value) => {
        this.filtro.sindicatos = value;
        this.sindicatosValidacao = value;
    }
    setFornecedores = (value) => {
        this.filtro.fornecedores = value;
        this.fornecedoresValidacao = value;
    }

    setCompetenciaInicio = (value) => {
        if(!moment(value).isValid()) {
            this.competenciaInicioValidacao = null;
            this.competenciaInicioSelecionada = null;
            this.filtro.competenciaInicio = null;
            return;
        }

        this.competenciaInicioValidacao = moment(value).format("DD/MM/YYYY");
        this.competenciaInicioSelecionada = moment(value, "DD-MM-YYYY");
        this.filtro.competenciaInicio = moment(value).format("YYYY-MM-DD");
    }

    setCompetenciaInicioCheck = (value) => {
        this.competenciaInicioValidacao = value;
    }

    setCompetenciaFim = (value) => {
        if(!moment(value).isValid()) {
            this.competenciaFimValidacao = null;
            this.competenciaFimSelecionada = null;
            this.filtro.competenciaFim = null;
            return;
        }

        this.competenciaFimValidacao = moment(value).format("DD/MM/YYYY");
        this.competenciaFimSelecionada = moment(value, "DD-MM-YYYY");
        this.filtro.competenciaFim = moment(value).format("YYYY-MM-DD");
    }

    setCompetenciaFimCheck = (value) => {
        this.competenciaFimValidacao = value;
    }

    setCompetenciaMesInicio = (value) => {
        if(value && value.year && value.month) {
            this.filtro.competenciaMesInicio = `${value.year}${pad(value.month, 2)}`;
            this.competenciaMesInicioValidacao = `01/${pad(value.month, 2)}/${value.year}`;
            this.competenciaMesInicioSelecionada = value;
        } else {
            this.filtro.competenciaMesInicio = null;
            this.competenciaMesInicioValidacao = null;
            this.competenciaMesInicioSelecionada = { year: null, month: null};
        }
    }

    setCompetenciaMesFim = (value) => {
        if(value && value.year && value.month) {
            this.filtro.competenciaMesFim = `${value.year}${pad(value.month, 2)}`;
            this.competenciaMesFimValidacao = `01/${pad(value.month, 2)}/${value.year}`;
            this.competenciaMesFimSelecionada = value;
        } else {
            this.filtro.competenciaMesFim = null;
            this.competenciaMesFimValidacao = null;
            this.competenciaMesFimSelecionada = { year: null, month: null};
        }
    }

    setProdutos = (value) => {
        this.filtro.produtos = value;
        this.produtosValidacao = value;
    }

    setCentrosCustoDebito = (value) => {
        this.filtro.centrosCustoDebito = value;
        this.centrosCustoDebitoValidacao = value;
    }

    toggleExcluindoSazonalidade = (reset) => {
        let value;
        if(reset) {
            value = false;
        } else {
            value = !this.filtro.excluindoSazonalidade;
        }

        this.filtro.excluindoSazonalidade = value;
        this.excluindoSazonalidadeSelecionada = value;
    }

    setDataInicial = (value) => {
        if(!moment(value).isValid()) {
            this.dataInicialValidacao = null;
            this.dataInicialSelecionada = null;
            this.filtro.dataInicial = null;
            return;
        }

        this.dataInicialValidacao = moment(value).format("DD/MM/YYYY");
        this.dataInicialSelecionada = moment(value, "DD-MM-YYYY");
        this.filtro.dataInicial = moment(value).format("YYYY-MM-DD");
    }

    setDataInicialCheck = (value) => {
        this.dataInicialValidacao = value;
    }

    setDataFinal = (value) => {
        if(!moment(value).isValid()) {
            this.dataFinalValidacao = null;
            this.dataFinalSelecionada = null;
            this.filtro.dataFinal = null;
            return;
        }

        this.dataFinalValidacao = moment(value).format("DD/MM/YYYY");
        this.dataFinalSelecionada = moment(value, "DD-MM-YYYY");
        this.filtro.dataFinal = moment(value).format("YYYY-MM-DD");
    }

    setDataFinalCheck = (value) => {
        this.dataFinalValidacao = value;
    }

    setSituacoesSolicitacao = (value) => {
        this.filtro.situacoesSolicitacao = value;
        this.situacoesSolicitacaoValidacao = value;
    }

    setSituacoesTimesheet = (value) => {
        this.filtro.situacoesTimesheet = value;
        this.situacoesTimesheetValidacao = value;
    }

    setJustificativas = (value) => {
        this.filtro.justificativas = value;
        this.justificativasValidacao = value;
    }

    setCompetenciaTerminoContrato = (value) => {
        if(value && value.year && value.month) {
            this.filtro.competenciaTerminoContrato = `${value.year}${pad(value.month, 2)}`;
            this.competenciaTerminoContratoSelecionada = value;
        } else {
            this.filtro.competenciaTerminoContrato = null;
            this.competenciaTerminoContratoSelecionada = { year: null, month: null};
        }
    }

    setQuantidadeAcessoConsecutivo = (value) => {
        if(value) {
            this.filtro.quantidadeAcessoConsecutivo = value;
            this.quantidadeAcessoConsecutivoSelecionada = value;
        } else {
            this.filtro.quantidadeAcessoConsecutivo = "";
            this.quantidadeAcessoConsecutivoSelecionada = "";
        }
    }

    setQuantidadeAcessoAlternado = (value) => {
        if(value) {
            this.filtro.quantidadeAcessoAlternado = value;
            this.quantidadeAcessoAlternadoSelecionada = value;
        } else {
            this.filtro.quantidadeAcessoAlternado = "";
            this.quantidadeAcessoAlternadoSelecionada = "";
        }
    }

    setCPF = (value) => {
        this.filtro.cpf = value;
        this.cpfSelecionado = value;
    }

    setMOTs = (value, options) => {
        if(value) {
            this.filtro.mots = (this.filtro.mots ? this.filtro.mots + "," : "") + _.last(options).id;
            this.motsSelecionados = value;
        } else {
            this.filtro.mots = "";
            this.motsSelecionados = "";
        }
    }

    setCompetencia = (value) => {
        if(value && value.year && value.month) {
            this.filtro.competencia = `${value.year}${pad(value.month, 2)}`;
            this.competenciaSelecionada = value;
        } else {
            this.filtro.competencia = null;
            this.competenciaSelecionada = { year: null, month: null};
        }
    }

    setNumeroLote = (value) => {
        if(value) {
            this.filtro.numeroLote = value;
            this.numeroLoteSelecionado = value;
        } else {
            this.filtro.numeroLote = "";
            this.numeroLoteSelecionado = "";
        }
    }

    setNumeroRC = (value) => {
        if(value) {
            this.filtro.numeroRc = value;
            this.numeroRCSelecionado = value;
        } else {
            this.filtro.numeroRc = "";
            this.numeroRCSelecionado = "";
        }
    }

    setNumeroOC = (value) => {
        if(value) {
            this.filtro.numeroOc = value;
            this.numeroOCSelecionado = value;
        } else {
            this.filtro.numeroOc = "";
            this.numeroOCSelecionado = "";
        }
    }

    setNumeroNF = (value) => {
        if(value) {
            this.filtro.numeroNF = value;
            this.numeroNFSelecionado = value;
        } else {
            this.filtro.numeroNF = "";
            this.numeroNFSelecionado = "";
        }
    }

    setAnoCorrente = (fields) => {
        const currentDate = moment();
        const oneYearAgoDate = moment().subtract(1, 'years');

        if(_.includes(fields, "COMPETENCIA_INICIO")) {
            this.competenciaInicioValidacao = oneYearAgoDate.format("DD/MM/YYYY");
            this.competenciaInicioSelecionada = oneYearAgoDate;
            this.filtro.competenciaInicio = oneYearAgoDate.format("YYYY-MM-DD");
        }

        if(_.includes(fields, "COMPETENCIA_FIM")) {
            this.competenciaFimValidacao = currentDate.format("DD/MM/YYYY");
            this.competenciaFimSelecionada = currentDate;
            this.filtro.competenciaFim = currentDate.format("YYYY-MM-DD");
        }
        if(_.includes(fields, "COMPETENCIA_MES_INICIO")) {
            let year;
            let month;
            if (this.dataInicialSelecionada) {
                year = this.dataInicialSelecionada.year();
                month = this.dataInicialSelecionada.month() + 1;
            } else {
                year = oneYearAgoDate.year();
                month = oneYearAgoDate.month() + 1;
            }

            this.filtro.competenciaMesInicio = `${year}${pad(month, 2)}`;
            this.competenciaMesInicioSelecionada = { year, month };
            this.competenciaMesInicioValidacao = `01/${pad(month, 2)}/${year}`;
        }

        if(_.includes(fields, "COMPETENCIA_MES_FIM")) {
            const year = currentDate.year();
            const month = currentDate.month() + 1;

            this.filtro.competenciaMesFim = `${year}${pad(month, 2)}`;
            this.competenciaMesFimSelecionada = { year, month };
            this.competenciaMesFimValidacao = `01/${pad(month, 2)}/${year}`;
        }

        if(_.includes(fields, "COMPETENCIA")) {
            const year = currentDate.year();
            const month = currentDate.month() + 1;
            
            this.filtro.competencia = `${year}${pad(month, 2)}`;
            this.competenciaSelecionada = { year, month };
        }
    }

    toggleExport = () => {
        this.exportOpen = !this.exportOpen;
    }

    getFiltro = () => {
        const filtro = { ...this.filtro,
            areas: stringToArray(this.filtro.areas),
            centrais: stringToArray(this.filtro.centrais),
            divisoes: stringToArray(this.filtro.divisoes),
            departamentos: stringToArray(this.filtro.departamentos),
            cargos: stringToArray(this.filtro.cargos),
            empresas: stringToArray(this.filtro.empresas),
            fornecedores: stringToArray(this.filtro.fornecedores),
            produtos: stringToArray(this.filtro.produtos),
            centrosCustoDebito: stringToArray(this.filtro.centrosCustoDebito),
            situacoesSolicitacao: stringToArray(this.filtro.situacoesSolicitacao),
            situacoesTimesheet: stringToArray(this.filtro.situacoesTimesheet),
            justificativas: stringToArray(this.filtro.justificativas),
            mots: stringToArray(this.filtro.mots),
            sindicatos: stringToArray(this.filtro.sindicatos),

        }

        return _.pickBy(filtro, _.identity);
    }

    limparFiltro = (fields) => {
        this.filtro = {};

        _.includes(fields, "AREA") && this.setAreas(null);
        _.includes(fields, "CENTRAL") && this.setCentrais(null);
        _.includes(fields, "DIVISAO") && this.setDivisoes(null);
        _.includes(fields, "DEPARTAMENTO") && this.setDepartamentos(null);
        _.includes(fields, "CARGO") && this.setCargos(null);
        _.includes(fields, "EMPRESA") && this.setEmpresas(null);
        _.includes(fields, "FORNECEDOR") && this.setFornecedores(null);
        _.includes(fields, "COMPETENCIA_INICIO") && this.setCompetenciaInicio(null) && setCompetenciaInicioCheck(null);
        _.includes(fields, "COMPETENCIA_FIM") && this.setCompetenciaFim(null) && setCompetenciaFimCheck(null);
        _.includes(fields, "COMPETENCIA_MES_INICIO") && this.setCompetenciaMesInicio(null);
        _.includes(fields, "COMPETENCIA_MES_FIM") && this.setCompetenciaMesFim(null);
        _.includes(fields, "PRODUTO") && this.setProdutos(null);
        _.includes(fields, "AR_DEBITO") && this.setCentrosCustoDebito(null);
        _.includes(fields, "SAZONALIDADE") && this.toggleExcluindoSazonalidade(true);
        _.includes(fields, "DATA_INICIAL") && this.setDataInicial(null) && setDataInicialCheck(null);
        _.includes(fields, "DATA_FINAL") && this.setDataFinal(null) && setDataFinalCheck(null);
        _.includes(fields, "SITUACAO_SOLICITACAO") && this.setSituacoesSolicitacao(null);
        _.includes(fields, "JUSTIFICATIVA") && this.setJustificativas(null);
        _.includes(fields, "COMPETENCIA_TERMINO_CONTRATO") && this.setCompetenciaTerminoContrato(null);
        _.includes(fields, "QUANTIDADE_ACESSO_CONSECUTIVO") && this.setQuantidadeAcessoConsecutivo(null);
        _.includes(fields, "QUANTIDADE_ACESSO_ALTERNADO") && this.setQuantidadeAcessoAlternado(null);
        _.includes(fields, "CPF") && this.setCPF(null);
        _.includes(fields, "MOT") && this.setMOTs(null);
        _.includes(fields, "COMPETENCIA") && this.setCompetencia(null);
        _.includes(fields, "NUMERO_LOTE") && this.setNumeroLote(null);
        _.includes(fields, "NUMERO_RC") && this.setNumeroRC(null);
        _.includes(fields, "NUMERO_OC") && this.setNumeroOC(null);
        _.includes(fields, "NUMERO_NF") && this.setNumeroNF(null);
        _.includes(fields, "SITUACAO_SOLICITACAO") && this.setSituacoesTimesheet(null);
        _.includes(fields, "TIPO_FILTRO_REL_SOLICITACOES") && this.setTipoFiltroRelSolicitacoes(null);
        _.includes(fields, "SINDICATO") && this.setSindicatos(null);

        this.erro = null;
    }

    carregarTipoFiltroRelSolicitacoes = () => {

        //this.tipoFiltroRelSolicitacoesValidacao = this.filtro.tipoFiltroRelSolicitacoes;

        this.tipoFiltroRelSolicitacoes = [{
            label: "Solicitações realizadas no período",
            value: "solicitacao"
        }, {
            label: "Contratos ativos no período",
            value: "contrato"
        }];
    }
    setTipoFiltroRelSolicitacoes = (value) => {
        if (value){
            this.filtro.tipoFiltroRelSolicitacoes = value;
            this.tipoFiltroRelSolicitacoesValidacao = value;
        } else{
            this.filtro.tipoFiltroRelSolicitacoes = null
            this.tipoFiltroRelSolicitacoesValidacao = null;
        }

    }

}
